/**
 * Jordanian dinar.
 */
export var JOD = {
  code: 'JOD',
  base: 10,
  exponent: 3
};